import { isAxiosError } from "axios"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { showToast } from "@/shared/utils"
import { postRejectOrder } from "@/api/dashboardApi"
import { useGlobalStore } from "@/store"

export const useRejectOrder = (originalOrderId: string, orderId: string) => {
  const queryClient = useQueryClient()
  const [carrierDashboardToken] = useGlobalStore((state) => [state.carrierDashboardToken])

  return useMutation(() => postRejectOrder(carrierDashboardToken, orderId), {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["dashboardData"],
      })
      showToast({ type: "success", text: `Order #${originalOrderId} was rejected.` })
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        showToast({ type: "error", text: `Order #${originalOrderId} hasn’t been rejected.` })
      }
    },
  })
}
